(() => {
  if (customElements.get('rr-support-chooser')) return;

  class RiotSupportChooser extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        window.addEventListener('hashchange', this.onHashChange);
        this.onHashChange();
        return;
      }
      this.select = this.querySelector('[data-hub-select]');
      this.control = this.querySelector('[data-hub-control]');
      this.intro = this.querySelector('[data-hub-intro]');
      this.status = this.querySelector('[data-hub-status]');
      this.topics = new Map(Array.from(this.querySelectorAll('[data-hub-topic]'), (topic) => [topic.dataset.hubTopic, topic]));
      if (!this.select || !this.control || !this.intro || !this.status || !this.topics.size) return;
      this.initialized = true;
      this.control.hidden = false;
      this.dataset.enhanced = 'true';
      this.select.addEventListener('change', () => this.showTopic(this.select.value, true));
      this.onHashChange = () => {
        const key = window.location.hash.slice(1);
        if (this.topics.has(key)) this.showTopic(key, false);
      };
      const initialKey = window.location.hash.slice(1);
      this.showTopic(this.topics.has(initialKey) ? initialKey : this.select.value, false);
      window.addEventListener('hashchange', this.onHashChange);
    }

    disconnectedCallback() {
      if (this.onHashChange) window.removeEventListener('hashchange', this.onHashChange);
    }

    showTopic(key, announce) {
      const selected = this.topics.has(key) ? key : '';
      this.select.value = selected;
      this.topics.forEach((topic, name) => {
        const active = name === selected;
        topic.hidden = !active;
        topic.open = active;
      });
      this.intro.hidden = Boolean(selected);
      if (announce && selected) {
        const label = this.select.selectedOptions[0]?.textContent || '';
        this.status.textContent = this.dataset.statusTemplate.replace('__topic__', label);
      } else this.status.textContent = '';
    }
  }

  customElements.define('rr-support-chooser', RiotSupportChooser);
})();
